import React, { Component } from "react";
import cn from "classnames";
import Modal from "react-modal";
import { Divider } from "shared/layout";
import Overlay from "shared/components/Overlay";
import { buildQAHook } from "shared/utils";
import config from "../../config";
import MenuLink from "../MenuLink";
import MenuLinkIcon from "../MenuLinkIcon";
import Submenu from "../Submenu";
import UserHeader from "../UserHeader";
import UserMenu from "../UserMenu";
import styles from "./styles.css";

class NavModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expandedId: "",
      isVisible: false,
      offsetTop: 0,
    };
  }

  componentDidMount() {
    this.headerNode = null;

    if (typeof document !== "undefined") {
      this.headerNode = document.getElementById("globalHeader");
    }

    if (this.headerNode) {
      Modal.setAppElement(this.headerNode);
    }
  }

  getOffsetTop = () => {
    let offsetTop = 0;

    if (this.headerNode) {
      offsetTop = this.headerNode.getBoundingClientRect().top;
    }

    return offsetTop;
  };

  show = () => {
    this.setState({
      isVisible: true,
      offsetTop: this.getOffsetTop(),
    });
  };

  hide = () => {
    const { onRequestClose } = this.props;

    this.setState({ isVisible: false }, onRequestClose);
  };

  toggleMenu = (event) => {
    const { expandedId } = this.state;
    const targetId = event.currentTarget.getAttribute("aria-controls");

    event.preventDefault();

    this.setState({
      expandedId: targetId === expandedId ? "" : targetId,
    });
  };

  render() {
    const { isOpen } = this.props;
    const { expandedId, isVisible, offsetTop } = this.state;

    return (
      <Modal
        isOpen={isOpen}
        overlayClassName={styles.modalOverlay}
        style={{ overlay: { top: `${offsetTop}px` } }}
        className={cn({
          [styles.wrapper]: true,
          [styles.isVisible]: isVisible,
        })}
        shouldCloseOnOverlayClick={false}
        onRequestClose={this.hide}
        onAfterOpen={this.show}
        closeTimeoutMS={200}
      >
        <Overlay
          className={styles.overlay}
          onClick={this.hide}
          style={{ top: `${offsetTop}px` }}
        />

        <nav className={styles.navigation} role="navigation">
          <UserHeader />

          <ul>
            {config.baseMobileMenu.items.map((item) => {
              const id = `${item.title.toLowerCase()}-menu-mobile`;
              const label = `${item.title.toLowerCase()}-heading-mobile`;

              return (
                <li key={item.title} className={styles.item}>
                  {item.submenu ? (
                    <MenuLink
                      onClick={this.toggleMenu}
                      aria-controls={id}
                      id={label}
                      data-qa={buildQAHook(item.title, "submenu", "link")}
                    >
                      {item.title}

                      <MenuLinkIcon expanded={id === expandedId} />
                    </MenuLink>
                  ) : (
                    <MenuLink
                      href={item.url}
                      isExternal={item.isExternal}
                      data-qa={buildQAHook(item.title, "menu", "link")}
                    >
                      {item.title}
                    </MenuLink>
                  )}
                  {item.submenu && item.submenu.items.length > 0 && (
                    <Submenu
                      id={id}
                      hidden={id !== expandedId}
                      aria-expanded={id === expandedId}
                      items={item.submenu.items}
                      featured={item.submenu.featured}
                      aria-labelledby={label}
                    />
                  )}
                </li>
              );
            })}
          </ul>

          <Divider className={styles.divider} />

          <UserMenu />
        </nav>
      </Modal>
    );
  }
}

export default NavModal;
